import { createContext, useContext, useState, type ReactNode } from 'react';

interface ConsultaModalContextValue {
    isOpen: boolean;
    preSelectedArea: string;
    open: (area?: string) => void;
    close: () => void;
}

const ConsultaModalContext = createContext<ConsultaModalContextValue | null>(null);

export const ConsultaModalProvider = ({ children }: { children: ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [preSelectedArea, setPreSelectedArea] = useState('');

    const open = (area = '') => {
        setPreSelectedArea(area);
        setIsOpen(true);
    };

    const close = () => setIsOpen(false);

    return (
        <ConsultaModalContext.Provider value={{ isOpen, preSelectedArea, open, close }}>
            {children}
        </ConsultaModalContext.Provider>
    );
};

export const useConsultaModal = () => {
    const ctx = useContext(ConsultaModalContext);
    if (!ctx) throw new Error('useConsultaModal must be used inside ConsultaModalProvider');
    return ctx;
};
